import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "flights_web_remove_fastest_sorting",
  stages: {
    main: 1,
    desktop: 2,
    mdot: 3,
    direct: 4,
    meta: 5,
    solo: 6,
    nonSolo: 7
  },
  defaultStage: 1,
  goals: {
    selectedBestSorting: 1,
    selectedCheapestSorting: 2,
    selectedGeniusSorting: 3,
    selectedFastestSorting: 4
  }
});

export const useTrackRemoveFastestSorting = () => {
  const { stages } = utils;
  const { isDesktop, isMobile, isMeta, isSolo } = useProfiler();

  isDesktop() && stages.desktop();
  isMobile() && stages.mdot();
  isMeta() ? stages.meta() : stages.direct();
  isSolo() ? stages.solo() : stages.nonSolo();
};

export default utils;
